/**
 * Ready-made Registry starter lists. `productIds` are document ids in the `catalogueItems`
 * collection, so a starter item is the same product (and goes through the same add-to-Registry
 * logic) as one picked by hand from the catalogue. To change a starter, edit its `productIds`.
 */
export const REGISTRY_STARTER_TEMPLATES = [
	{
		id: "dorm-room",
		title: "Dorm Room Starter",
		description: "12 essentials for dorm life",
		productIds: [
			"6NgaIUhDquueRhvlMPV1", // Twin XL bed in a bag
			"3a5msQJomxRQgWg7iCcV", // Pillows
			"JnRNox8mOLMES3nCgIRS", // Twin XL mattress topper
			"4cJMkfyjAqdgNVjUSDFK", // Towel set
			"9GLXarXxPpp2XbIgXGP0", // Shower caddy
			"3esDnLio01A0IXsk5A5B", // Shower shoes
			"QAZ1sMcGEg0DzOnJktwq", // Laundry basket
			"EfcedvwmoeOEg3mYySGa", // Desk lamp
			"FrG8kUdfRVMJoGe0opCW", // Surge protector
			"g9ZzOjUmJNBuNXrLVD1p", // Under-bed storage
			"Zd7FfRRzfhPfQs1RCXGG", // Mini fridge
			"0yspfhpu4IJVpnJh8d4n", // Over-the-door organizer
		],
	},
	{
		id: "first-apartment",
		title: "First Apartment Starter",
		description: "12 essentials for your first place",
		productIds: [
			"3KQJ6QORekRnWEogPi5w", // Queen sheet set
			"XtkDcjjV36TQnkzmXHeM", // Queen comforter set
			"5atbMWmrYVaVu5vBn93w", // Towel set
			"CvusGS4Rdbo4GIvINI6J", // Shower curtain
			"J7EbCzsIA7CWwjcIPJwV", // Bath rug
			"MgZYEPnijkovKHnEL14c", // Dinnerware set
			"0aP2LkJ9G7CKt6qW55tB", // Silverware set
			"8Rnu8aR75ktUeyacRxSM", // Pots and pans
			"MbP2ow54U7VTmpB9kgph", // Cooking utensils
			"7hBeSZMCGo3AbIc1AycG", // Coffee maker
			"CanbFUlLUzP4NiK0krxS", // Stick vacuum
			"2jpEhus3yH0WPi4KhukH", // Floor lamp
		],
	},
];

export const getStarterTemplate = (templateId) => REGISTRY_STARTER_TEMPLATES.find((template) => template.id === templateId) || null;
